<template>
	<router-link class="btn btn-icon-text" :to="to">
		<svgicon :name="icon" :fill="false"/>
		<span>
			<slot/>
		</span>
	</router-link>
</template>

<script>
export default {
	props: [
		'to',
		'icon'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonIconText.vue